import { render, staticRenderFns } from "./DoubleOrderConfirmation.vue?vue&type=template&id=90d531fc&scoped=true&"
import script from "./DoubleOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./DoubleOrderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DoubleOrderConfirmation.vue?vue&type=style&index=0&id=90d531fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d531fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconClose: require('/opt/build/repo/components/icons/IconClose.vue').default})
